import React from 'react';

function Intro() {
    return (
        <div>
            <h2 className="intro">
                React with Redux
            </h2>
        </div>
    );
}

export default Intro;